import * as React from 'react';
import * as moment from 'moment';
import { compose } from 'recompose';
import { injectIntl, InjectedIntlProps, FormattedMessage } from 'react-intl';

import Logo from '../../../../components/Logo';
import WordsCount, { IWordsCountProps } from '../../../../components/WordsCount';

import IMPComponent from '../../../../components/interfaces/IMPComponent';

import { DefaultDateFormats } from '../../../../constants/dateFormats';

import './styles.scss';
import { CentralSection, HeaderContainer, LeftSection, RightSection } from '../../../../components/Header';

interface IPageEditorHeaderProps extends IMPComponent, IWordsCountProps {
  onSave: () => void;
  onCancel: () => void;
  selectedDate: string;
  isEditing: boolean;
  canSave: boolean;
}

const enhance = compose<IPageEditorHeaderProps & InjectedIntlProps, IPageEditorHeaderProps>(injectIntl);

const PageEditorHeader: React.FunctionComponent<IPageEditorHeaderProps & InjectedIntlProps> = ({
  className,
  style,
  selectedDate,
  intl: { formatMessage },
  expectedWordsCount,
  actualWordsCount,
  isEditing,
  onCancel,
  onSave,
  canSave,
}) => {
  const date = moment(selectedDate);
  const isToday = date.isSame(moment(), 'day');

  const todayLabel = formatMessage({
    id: 'containers.PagesHistory.PageEditor.PageEditorHeader.todayLabel',
  });

  const saveButtonText = isEditing ? 'doneButtonText' : 'saveButtonText';

  return (
    <HeaderContainer>
      <LeftSection>
        <Logo>
          {isToday && todayLabel} {date.format(DefaultDateFormats.pageEditor)}
        </Logo>
      </LeftSection>
      <CentralSection>
        <WordsCount actualWordsCount={actualWordsCount} expectedWordsCount={expectedWordsCount}>
          <FormattedMessage id="containers.PagesHistory.PageEditor.PageEditorHeader.wordsCountLabel" />
        </WordsCount>
      </CentralSection>
      <RightSection>
        <button className="PageEditorHeader-actionButton PageEditorHeader-actionButton--cancel" onClick={onCancel}>
          <FormattedMessage id="containers.PagesHistory.PageEditor.PageEditorHeader.cancelButtonText" />
        </button>
        <button
          className="PageEditorHeader-actionButton PageEditorHeader-actionButton--save"
          disabled={!canSave}
          onClick={onSave}
        >
          <FormattedMessage id={`containers.PagesHistory.PageEditor.PageEditorHeader.${saveButtonText}`} />
        </button>
      </RightSection>
    </HeaderContainer>
  );
};

export default enhance(PageEditorHeader);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PageEditor/PageEditorHeader/index.tsx